var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form form-search d-flex flex-col justify-content-center",
      attrs: { action: "/explosive-hazards/all-hazards" }
    },
    [
      _c("div", { staticClass: "field position-relative w-100" }, [
        _c("div", { staticClass: "control" }, [
          _c("input", {
            staticClass: "input w-100 border-radius",
            attrs: {
              name: "query",
              type: "text",
              placeholder: "E.g. Type 58 Landmine"
            },
            domProps: { value: _vm.query }
          })
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm._m(1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "control" }, [
      _c("button", { staticClass: "btn btn-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-sm mx-auto mt-3 px-3 text-center" }, [
      _vm._v("\n        You may also search by "),
      _c("div", { staticClass: "block sm:hidden" }),
      _c(
        "a",
        {
          staticClass: "text-[#E57722] underline font-medium",
          attrs: { href: "/explosive-hazards/incidents" }
        },
        [_vm._v("Incidents")]
      ),
      _vm._v(" or "),
      _c(
        "a",
        {
          staticClass: "text-[#E57722] underline font-medium",
          attrs: { href: "/explosive-hazards/terrorist-groups" }
        },
        [_vm._v("Terrorist Groups")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fefb60b0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fefb60b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchBox.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-fefb60b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SearchBox.vue
// module chunks = 0 1